import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProductFilter } from '../models/filters/product-filter';
import { PartialResult } from '../models/generics/PartialResult';
import { Product } from '../models/products/product';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private httpClient = inject(HttpClient);
  private controllerUrl = environment.apiBaseUrl + '/api/' + environment.apiVersion + '/product/';

  getProducts(filter: ProductFilter): Observable<PartialResult<Product>> {
    return this.httpClient.get<PartialResult<Product>>(this.controllerUrl, {
      params: {
        Offset: filter.offset?.toString(),
        Amount: filter.amount?.toString(),
        Name: filter.name,
        SearchAll: filter.searchAll,
        Description: filter.description,
        Id: filter.id
      }
    });
  }

  deleteProduct(id: string): Observable<any> {
    return this.httpClient.delete(this.controllerUrl + id);
  }

  createProduct(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.controllerUrl, product);
  }

  updateProduct(product: Product): Observable<Product> {
    return this.httpClient.put<Product>(this.controllerUrl, product);
  }
}
